$(function() {
    $(window).on("scroll", function() {
        backToTop();
        whatsApp();
    });

    AOS.init({
        duration: 1000,
        easing: 'ease-in-out',
        once: true,
        mirror: false
    });

    datepicker();

    GLightbox({
        selector: '.lightbox'
    });

    if (window.location.hash) {
        let section = $(window.location.hash);
        if (!section) return false;
        scrollTo(section);
    }
});
